<template>
  <Modal title="学生请假" v-model="visible" width="880">
    <Form ref="leaveForm" class="form" :label-width="80"
      :model="leaveParam" :rules="leaveRule">
      <Row>
        <Col span="4">
        <FormItem label="请假类型：" >
          <Select v-model="showModal.showModel" style="width:150px" transfer>
            <Option :value=1>请单节课</Option>
            <Option :value=2>请长假</Option>
            <Option :value=3>申请停课</Option>
          </Select>
        </FormItem>
        </Col>
      </Row>
      <Row>
        <Col :span="22"  v-if="showModal.showModel == 1">
        <Form-item label="选择课程：" prop="status">
          <Select v-model="showModal.id" style="width: 300px" transfer>
            <Option v-for="item in userLessonOpend" :value="item.id" :key="item.id">{{ item.stringLsnTime }} {{ item.lessonTitle }}</Option>
          </Select>
        </Form-item>
        </Col>
        <!--<Col :span="16" v-if="showModal.showModel == 1">-->
          <!--<Form-item prop="isSixHoursAgo" label="是否3小时前：">-->
            <!--<RadioGroup v-model="leaveParam.isSixHoursAgo">-->
              <!--<Radio label="0">-->
                <!--<span>否</span>-->
              <!--</Radio>-->
              <!--<Radio label="1">-->
                <!--<span>是</span>-->
              <!--</Radio>-->
            <!--</RadioGroup>-->
          <!--</Form-item>-->
        <!--</Col>-->
        <Col :span="22"  v-if="showModal.showModel == 2 || showModal.showModel == 3">
          <Form-item label="选择时间">
            <Row>
              <Col span="6">
                <Form-item prop="startTime" >
                  <Date-picker  type="datetime" format="yyyy-MM-dd HH:mm" placeholder="开始时间"
                    :value="leaveParam.startTimeStr"
                    @on-change="startTimeChange"></Date-picker>
                </Form-item>
              </Col>
              <Col span="1" style="text-align: center"> - </Col>
              <Col span="6">
                <Form-item prop="endTime">
                  <Date-picker type="datetime" format="yyyy-MM-dd HH:mm" placeholder="结束时间"
                    :value="leaveParam.endTimeStr"
                    @on-change="endTimeChange"></Date-picker>
                  </Form-item>
              </Col>
              <Col span="3">
                <Button type="info" :loading="loadingSearch" @click="onBookLessonOpened">查看涉及课节</Button>
              </Col>
            </Row>
          </Form-item>
        </Col>
        <Col :span="16">
          <Form-item label="请假原因" prop="remark">
            <Input type="textarea" :autosize="{minRows: 2,maxRows: 3}" :maxlength="100"
              placeholder="长度不要超过100个字符"
              v-model="leaveParam.remark" ></Input>
          </Form-item>
        </Col>
      </Row>
    </Form>
    <Table class="compact" size="small" :columns="bookLessonOpenedColumn" :data="bookLessonOpenedList" v-if="showModal.showModel == 2 || showModal.showModel == 3"></Table>
    <div slot="footer">
      <Button type="text" size="large" @click="visible=false">取消</Button>
      <Button type="primary" size="large" :loading="loadingAdd" @click="add">保存</Button>
    </div>
  </Modal>
</template>
<script>
  import { fetchTchScoreMap, applyTchScoresToRows, renderTchNameWithScore } from '@/utils/tchScore'
export default {
    name: 'UserLeaveModal',
    props: {
      value: {
        type: Boolean,
        default: false
      },
      uid: {
        type: Number,
        default: false
      },
      successCallback: {
        type: Function
      }
    },
    data () {
      let self = this
      let $constant = this.$constant
      let $moment = this.$moment
      return {
      rankScoreSeq: 0,
        visible: this.value,
        bookLessonOpenedList: [],
        userLessonOpend: [],
        bookLessonOpenedColumn: [
          {
            title: '学生ID、姓名',
            width: 100,
            render: (h, params) => {
              let row = params.row
              return h('div', [
                h('span', row.uid),
                h('span', ' - '),
                h('span', row.userNickname || '')
              ])
            }
          },
          {
            title: '老师ID、姓名',
            width: 180,
            render: (h, params) => {
              let row = params.row
              return renderTchNameWithScore(h, {
                text: row.tchId + ' - ' + ((row.tchFirstName || '') + ' ' + (row.tchLastName || '')).trim(),
                score: row.monthRankScore
              })
            }
          },
          {
            title: '学导',
            width: 90,
            key: 'studyAdviserNickname'
          },
          {
            title: '外教运营',
            width: 90,
            key: 'adviserNickname'
          },
          {
            title: '开始、结束时间',
            align: 'center',
            width: 122,
            render: (h, params) => {
              let lsnBeginTime = params.row.lsnBeginTime
              let lsnEndTime = params.row.lsnEndTime
              return h('span', $moment(lsnBeginTime, 'X').format('YYYY-MM-DD HH:mm') + ' ' + $moment(lsnEndTime, 'X').format('YYYY-MM-DD HH:mm'))
            }
          },
          {
            title: '上课类型',
            align: 'center',
            width: 72,
            render: (h, params) => {
              let lsnType = params.row.lsnType
              let typeEnum = $constant.getEnum($constant.bookLessonOpenedLsnType, lsnType)
              return h('span', typeEnum && typeEnum.text)
            }
          },
          {
            title: '课程名称',
            key: 'lessonTitle'
          },
          {
            title: '上课时长',
            align: 'center',
            width: 72,
            key: 'courseTime'
          },
          {
            title: '上课状态',
            width: 72,
            render: (h, params) => {
              let lsnSelStatus = params.row.lsnSelStatus
              let statusEnum = $constant.getEnum($constant.lsnSelStatus, lsnSelStatus)
              return h('span', statusEnum && statusEnum.text)
            }
          }
        ],
        loadingSearch: false,
        loadingAdd: false,
        leaveParam: {
          leaveType: 1,
          startTime: '',
          endTime: '',
          remark: '',
          day: '',
          isSixHoursAgo: 0
        },
        showModal: {
          showModel: 1,
          id: ''
        },
        leaveRule: {
          startTime: [
            { required: true, message: '请选择开始时间', trigger: 'change' },
            { validator (rule, value, callback, source, options) {
              let endTime = self.leaveParam.endTime
              let errors = []
              let nowTime = new Date().getTime() / 1000
              if (nowTime >= value) {
                errors.push('开始时间应在当前时间之后')
              }
              if (endTime !== '' && value >= endTime) {
                errors.push('开始时间应在结束时间之前')
              }
              callback(errors)
            } }
          ],
          endTime: [
            { required: true, message: '请选择结束时间', trigger: 'change' }
          ],
          remark: [
            { type: 'string', required: true, message: '请填写请假原因', trigger: 'blur' },
            { type: 'string', max: 100, message: '长度不要超过100个字符', trigger: 'blur' }
          ],
        },
      }
    },
    methods: {
    loadMonthRankScores () {
      const table = this.bookLessonOpenedList
      if (!table || !table.length) {
        return
      }
      const ids = table.map(function (row) { return row.tchId }).filter(function (id) { return id != null })
      const seq = ++this.rankScoreSeq
      const self = this
      fetchTchScoreMap(this.$http, ids).then(function (map) {
        if (seq !== self.rankScoreSeq) {
          return
        }
        applyTchScoresToRows(self, table, 'tchId', 'monthRankScore', map)
      })
    },

      add () {
        let self = this
        self.loadingAdd = true
        if (self.showModal.showModel === 1) {
          this.$refs.leaveForm.validate((valid) => {
            if (!valid) {
              self.loadingAdd = false
              return
            }
            self.$http.post('/bookUserLeaveTime/addByOpenedId', {
              openedId: self.showModal.id,
              remark: self.leaveParam.remark,
              isSixHoursAgo: self.leaveParam.isSixHoursAgo
            }).then(function (res) {
              self.loadingAdd = false
              if (res && res.data > 0) {
                self.$Message.success('请假成功!')
                self.visible = false
                self.successCallback()
              }
            })
          })
        } else {
          var nTime = this.leaveParam.endTime - this.leaveParam.startTime
          var day = Math.floor(nTime / 86400)
          this.leaveParam.day = day
          this.leaveParam.leaveType = this.showModal.showModel
          this.$refs.leaveForm.validate((valid) => {
            if (!valid) {
              return
            }
            if (self.showModal.showModel === 2) {
              if (day > 7) {
                self.$Message.warning('时间超过7天,请申请停课')
                return
              }
            }
            self.loadingAdd = true
            let params = self.leaveParam
            params.uid = self.uid
            if (day > 20) {
              self.loadingAdd = false
              self.$Modal.confirm({
                title: '提示',
                content: '停课时间大于20天，确定请假后立即解除绑定老师，假期结束后需要您重新绑定',
                width: 300,
                loading: true,
                onOk: () => {
                  self.$http.post('/bookUserLeaveTime/add', params).then(function (res) {
                    self.$Message.success('解绑成功!')
                    self.$Modal.remove()
                    self.visible = false
                    self.successCallback()
                  })
                }
              })
            } else {
              self.$http.post('/bookUserLeaveTime/add', params).then(function (res) {
                self.loadingAdd = false
                if (res && res.data > 0) {
                  self.$Message.success('请假成功!')
                  self.visible = false
                  self.successCallback()
                }
              }).catch(function (e) {
                self.loadingAdd = false
              })
            }
          })
        }
      },
      startTimeChange (value) {
        this.leaveParam.startTime = value && this.$moment(value, 'YYYY-M-D H:m').format('X')
      },
      endTimeChange (value) {
        this.leaveParam.endTime = value && this.$moment(value, 'YYYY-M-D H:m').format('X')
      },
      onBookLessonOpened () {
        let self = this
        let isNotError = true
        this.$refs.leaveForm.validateField('startTime', (valid) => {
          if (valid !== '') isNotError = false
        })
        this.$refs.leaveForm.validateField('endTime', (valid) => {
          if (valid !== '') isNotError = false
        })
        if (!isNotError) return
        self.loadingSearch = true
        let params = {}
        params.uid = self.uid
        params.startTime = self.leaveParam.startTime
        params.endTime = self.leaveParam.endTime
        self.$http.get('/bookLesson/userLeave/list', { params: params }).then(function (res) {
          self.loadingSearch = false
          if (res.data.length <= 0) {
            self.$Message.info('没有涉及任何课节!')
            return
          }
          self.bookLessonOpenedList = res.data
          self.loadMonthRankScores()
        })
      },
    },
    watch: {
      value (val) {
        this.visible = val
      },
      visible (val) {
        if (val === false) {
          this.bookLessonOpenedList = []
         // this.$refs.leaveForm.resetFields()
          this.leaveParam = {
            startTime: '',
            endTime: '',
            startTimeStr: '',
            endTimeStr: '',
            remark: ''
          }
          this.$emit('on-close', val)
        }
        this.$emit('input', val)
      },
      uid (val) {
        let self = this
        if (val) {
          self.$http.get('/bookLesson/selectUserLesson?uid=' + val).then(res => {
            self.userLessonOpend = res.data
          })
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// UserLeaveModal.vue?6c16fede